import StandardError from './Standard'

class ForbiddenError extends StandardError {
  constructor(message = 'User is not authorized', status = 403, body = {}) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default ForbiddenError
